export function formatTimestamp(timestamp: string): string {
  // Create a new Date object from the timestamp
  const date = new Date(timestamp);

  // Options for the date formatting
  const options: Intl.DateTimeFormatOptions = {
    weekday: "short", // Thu
    day: "2-digit", // 18
    month: "short", // Jul
    year: "2-digit", // 24
    hour: "numeric", // 2
    minute: "numeric", // 16
    hour12: true, // pm
  };

  // Format the date using the user's locale and time zone
  return date.toLocaleString(undefined, options);
}

export function formatDayTimestamp(timestamp: string): string {
  // Create a new Date object from the timestamp
  const date = new Date(timestamp);

  // Options for the date formatting
  const options: Intl.DateTimeFormatOptions = {
    weekday: "short", // Thu
    day: "2-digit", // 18
    month: "short", // Jul
    year: "2-digit", // 24
  };

  // Format the date using the user's locale and time zone
  return date.toLocaleString(undefined, options);
}

export const toISOString = (date: Date): string => {
  // Ensure the date is a valid Date object
  try {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return "Invalid date";
    }
    // Convert the date to ISO string format
    return date.toISOString();
  } catch (error) {
    console.error("Error converting date to ISO string:", error);
    return "Invalid date";
  }
};

export function addHoursToTimestamp(timestamp: string, hours: number): string {
  console.log("timestamp", timestamp);
  // Create a new Date object from the timestamp
  const date = new Date(timestamp);
  console.log("date", date);

  // Add the specified number of hours
  date.setHours(date.getHours() + hours);
  console.log("date", date);

  // Return the updated timestamp in ISO format
  return toISOString(date);
}

export function isEmptyString(value: string) {
  return value === null || value === undefined || value === "";
}

/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-empty-function */
const { REACT_APP_DEBUG_LOG } = process.env;
const infoRegEx = /true|info/i;
const debugRegEx = /true|debug/i;
const warnRegEx = /true|warn/i;
// const errorRegEx = /error|true/i;

export const logerror = console.error;

export const warnlog = REACT_APP_DEBUG_LOG
  ? REACT_APP_DEBUG_LOG.match(warnRegEx)
    ? console.log
    : () => {}
  : () => {};

export const infolog = REACT_APP_DEBUG_LOG
  ? REACT_APP_DEBUG_LOG.match(infoRegEx)
    ? console.log
    : () => {}
  : () => {};

export const debuglog = REACT_APP_DEBUG_LOG
  ? REACT_APP_DEBUG_LOG.match(debugRegEx)
    ? console.log
    : () => {}
  : () => {};

/** usage
 * var jsonString = JSON.stringify(object, circularReplacer());
 * Creating new WeakSet to keep track of previously seen objects
 * */
export const circularReplacer = () => {
  const seen = new WeakSet();

  return (_key: any, value: object | null) => {
    // If type of value is an
    // object or value is null
    if (typeof value === "object" && value !== null) {
      // If it has been seen before
      if (seen.has(value)) {
        //console.log(value);
        return { Circular: Object.keys(value) };
      }

      // Add current value to the set
      seen.add(value);
    }

    // return the value
    return value;
  };
};

export function formatDateTime(dateStr, timeStr) {
  if (!dateStr || !timeStr) {
    return "";
  }
  // Check if the date string is in the format "YYYY-MM-DD" or "DD-MM-YYYY"
  const datePattern = /^\d{4}-\d{2}-\d{2}$/;
  const isDateValid = datePattern.test(dateStr);
  if (!isDateValid) {
    // If the date string is not valid, return an error message
    return "";
  }
  const [hour, minute] = timeStr.split(":");
  const date = new Date(`${dateStr}T${hour}:${minute}`);

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const dayName = days[date.getDay()];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  const suffix = ((d) => {
    if (d > 3 && d < 21) return "th";
    switch (d % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  })(day);

  let hour12 = date.getHours() % 12 || 12;
  const meridiem = date.getHours() < 12 ? "am" : "pm";
  const minuteStr = date.getMinutes().toString().padStart(2, "0");

  return `${hour12}.${minuteStr} ${meridiem} ${dayName} ${day}${suffix} ${month} ${year}`;
}

/**
 * Format a date string into a human-readable format
 * Example output: "2.30 pm Thu 18th Jul 24"
 */
export function formatDate(dateString: string): string {
  try {
    const dateObj = new Date(dateString);
    if (isNaN(dateObj.getTime())) {
      return "";
    }

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const year = dateObj.getFullYear();
    const monthIndex = dateObj.getMonth();
    const monthName = months[monthIndex];
    const dayOfMonth = dateObj.getDate();
    const dayOfWeekIndex = dateObj.getDay();
    const dayOfWeek = daysOfWeek[dayOfWeekIndex];
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();

    const dayOfMonthSuffix = getDayOfMonthSuffix(dayOfMonth);
    const formattedTime = formatTime(hours, minutes);

    return `${formattedTime} ${dayOfWeek} ${dayOfMonth}${dayOfMonthSuffix} ${monthName} ${year % 100}`;
  } catch (error) {
    console.error("Error formatting date:", error);
    return "No time slots available";
  }
}

/**
 * Get the appropriate suffix for a day of the month
 * Example: 1 -> "st", 2 -> "nd", 3 -> "rd", 4 -> "th"
 */
export function getDayOfMonthSuffix(day: number): string {
  if (day >= 11 && day <= 13) {
    return "th";
  }
  const lastDigit = day % 10;
  switch (lastDigit) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}

/**
 * Format hours and minutes into a 12-hour time format with am/pm
 * Example: 14, 30 -> "2.30 pm"
 */
export function formatTime(
  hours: number | string,
  minutes: number | string
): string {
  // Ensure we're working with numbers
  const h = typeof hours === "string" ? parseInt(hours, 10) : hours;
  const m = typeof minutes === "string" ? parseInt(minutes, 10) : minutes;

  const period = h >= 12 ? "pm" : "am";
  const hourIn12HourFormat = h % 12 || 12;
  return `${hourIn12HourFormat}.${m.toString().padStart(2, "0")} ${period}`;
}

/**
 * Parse a date string in various formats and return a formatted date string
 * This function can handle ISO strings, date objects, or date parts
 */
export function parseAndFormatDate(
  dateInput: string | Date,
  timeInput?: string
): string {
  try {
    let dateObj: Date;

    if (dateInput instanceof Date) {
      dateObj = dateInput;
    } else if (typeof dateInput === "string") {
      // Check if it's an ISO date string
      if (dateInput.includes("T") || dateInput.includes("-")) {
        dateObj = new Date(dateInput);
      }
      // Check if it's a date in "DD-MM-YYYY" format
      else if (dateInput.includes("-")) {
        const [day, month, year] = dateInput.split("-");
        dateObj = new Date(`${year}-${month}-${day}`);
      } else {
        dateObj = new Date(dateInput);
      }

      // If a separate time is provided, merge it with the date
      if (timeInput && typeof timeInput === "string") {
        const [hours, minutes] = timeInput.split(":");
        dateObj.setHours(parseInt(hours, 10), parseInt(minutes, 10));
      }
    } else {
      return "Invalid date format";
    }

    if (isNaN(dateObj.getTime())) {
      return "No time slots available";
    }

    return formatDate(toISOString(dateObj));
  } catch (error) {
    console.error("Error parsing and formatting date:", error);
    return "";
  }
}

export const isValidDate = (date) => {
  // Check if the date is not null, undefined, or an empty string
  if (!date || date === "") {
    return false;
  }

  // Check for known invalid formats
  if (
    date === "12.00 am Sat 1st Jan 2000" ||
    date.includes("NaN") ||
    date.includes("undefined")
  ) {
    return false;
  }

  return true;
};

export const convertAppointment = (obj) => {
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const dateObj = new Date(obj.date);
  const day = days[dateObj.getUTCDay()];
  const dayNum = String(dateObj.getUTCDate()).padStart(2, "0");
  const month = dateObj.toLocaleString("en-AU", {
    month: "short"
  });

  // Convert formattedTime to 24-hour time string
  const [timePart, period] = obj.formattedTime.split(" ");
  let [hours, minutes] = timePart.split(".").map(Number);
  if (period.toLowerCase() === "pm" && hours !== 12) hours += 12;
  if (period.toLowerCase() === "am" && hours === 12) hours = 0;
  const newTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;

  // Convert time to formattedTime in AM/PM format
  const formattedTimeDate = new Date(`2025-05-14T${newTime}:00`);
  const formattedTime = formattedTimeDate.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return {
    formattedDate: `${day} ${dayNum} ${month}`,
    formattedTime,
    date: obj.date,
    time: newTime,
    duration: obj.duration,
  };
};
